import { ELanguage, Environment as ETSEnvironment } from 'ets-fe-ng-sdk';
import { signal } from '@angular/core';
import { EDashboardView, ESystem } from 'projects/shared/src/lib/models/index.model';

export class Environment extends ETSEnvironment {
  override appRoutes: any;
  override sourceLanguage!: ELanguage;
  override _targetLanguage?: ELanguage;
  _token?: string;
  system!: ESystem;
  remitaARIANPK: string =
    'QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=';
  remitaNAICOMPK: string =
    'QzAwMDAyNzEyNTl8MTEwNjE4NjF8OWZjOWYwNmMyZDk3MDRhYWM3YThiOThlNTNjZTE3ZjYxOTY5NDdmZWE1YzU3NDc0ZjE2ZDZjNTg1YWYxNWY3NWM4ZjMzNzZhNjNhZWZlOWQwNmJhNTFkMjIxYTRiMjYzZDkzNGQ3NTUxNDIxYWNlOGY4ZWEyODY3ZjlhNGUwYTY=';
  remitaCIFMPK: string =
    this.remitaNAICOMPK ||
    `QzAwMDA3NDQ4NDZ8MTQ5MDg3NzE3ODh8N2U0ODQwODJhMGYwM2I1YzM0MzlkNjUyMWYyMDFmZTY4NjgxNmUyNmE2NTljNDM5MWFiYzZlOGNjOTcyYTM0YzY4NjMzMjU0YmY0NzU2ZGY2MDU0YTBjZjcyMzlmYTI5Y2EwN2YwYTE3YzY2OTM0ZTNjZTY1MzVjNDYxY2NjYTY=`;
  userCompanyCode?: string;
  readonly userCompanyCodeSignal = signal<string | undefined>(undefined);
  defaultDashboard?: EDashboardView;
  candidateURL: string = `https://staging-candidate-naicom.evoluticstech.com`;
  partnerURL: string = `https://staging-cifm-naicom.evoluticstech.com`;
  adminURL: string = `https://staging-naicom.evoluticstech.com`;
  remitaBaseURL = `https://remitademo.net/`;
  useRemita = true;
  adminUsername?: string;
  adminPassword?: string;
  override logActivities: boolean = true;
  override versionNo?: string = '0.0.2';
  helpEmail = 'osagie@evoluticstech.com';
  public override get targetLanguage(): ELanguage {
    return super.targetLanguage as ELanguage;
  }
  override set targetLanguage(value: ELanguage) {
    super.targetLanguage = value;
  }
  override apiBaseUrl!: string;
  apiWorkflowBaseUrl!: string;
  mainWebsiteURL: string = 'https://www.naicom.gov.ng';
  apiGatewayBaseUrl!: string;
  apiMessagingBaseUrl?: string;
  apiPolicyBaseUrl!: string;
  apiUserServiceBaseUrl?: string;
  apiNasBaseUrl = 'https://nas-service.evoluticstech.com/nas-service/api/';
  override authenticate = true;
  ownerAppName: string = 'NAICOM';
  // allowRegistration = true;

  override get token() {
    return this._token;
  }

  get isCandidate() {
    return this.system == ESystem.candidate;
  }
  get isAdmin() {
    return this.system == ESystem.admin;
  }
  get isCRM() {
    return this.system == ESystem.crm;
  }
  get isPartner() {
    return this.system == ESystem.partner;
  }
}
